<div class="active-filters-counter">
  <!-- Botão contador de filtros -->
  <button 
    mat-button 
    class="filters-counter-button" 
    [class.has-filters]="activeFiltersCount() > 0"
    (click)="toggleSummaryPanel()"
    [matTooltip]="activeFiltersCount() > 0 ? 'Ver filtros aplicados' : 'Nenhum filtro aplicado'"
    matTooltipPosition="below">
    <mat-icon>filter_list</mat-icon>
    <span class="counter-text" [@counterAnimation]="activeFiltersCount()">
      {{ activeFiltersCount() }} 
      {{ activeFiltersCount() === 1 ? 'filtro ativo' : 'filtros ativos' }}
    </span>
    @if (activeFiltersCount() > 0) {
      <mat-icon class="expand-icon" [class.expanded]="showSummary()">
        {{ showSummary() ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    }
  </button>
  
  <!-- Painel de resumo de filtros -->
  @if (showSummary() && activeFiltersCount() > 0) {
    <div class="summary-panel" [@slideIn]>
      <div class="summary-header">
        <h3>Filtros Aplicados</h3>
        <button 
          mat-button 
          color="warn" 
          (click)="clearAllFilters()"
          class="clear-all-button">
          <mat-icon>clear_all</mat-icon>
          Limpar todos
        </button>
      </div>
      
      <div class="summary-content">
        @for (category of categories(); track category) {
          <div class="filter-category" [@fadeIn]>
            <h4 class="category-title">{{ category }}</h4>
            <mat-chip-set class="filter-chips">
              @for (filter of getFiltersForCategory(category); track filter.fieldName) {
                <mat-chip 
                  class="filter-chip"
                  (removed)="clearFilter(filter)"
                  (click)="navigateToFilter(filter.fieldName)"
                  [@chipAnimation]
                  [matTooltip]="'Clique para editar ou remover'"
                  matTooltipPosition="above">
                  <span class="chip-label">{{ filter.label }}:</span>
                  <span class="chip-value">{{ filter.value }}</span>
                  <button matChipRemove [attr.aria-label]="'Remover filtro ' + filter.label">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
              }
            </mat-chip-set>
          </div>
        }
      </div>
    </div>
  }
</div>
